export default __webpack_public_path__ + "static/media/close-icon.d6ae5151.svg";